
<template>
  <div class="d-flex flex-column mt-5 mx-auto menuBotoes">
    <!-- :to="{ path: item.rota }" -->
    <template>
      <v-btn v-for="(item, index) in menuBotoes" :key="index" :class="item.class" dark :to="{ name: item.name }"
        :target="item.target">
        <v-icon dark left> {{ item.icon }} </v-icon>
        {{ item.title }}
      </v-btn>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "HomeView",
  components: {
    // HelloWorld,
  },
  data: () => ({}),
  methods: {},
  computed: {
    menuBotoes() {
      return [
        {
          title: this.$i18n.t("home.ConsultarContrato"),
          icon: "mdi-magnify",
          name: "ConsultarContrato",
          rota: "/app/consultar_contrato",
          target: "_self",
          class: "py-7 mt-7",
        },
        {
          title: this.$i18n.t("home.GerarContrato"),
          icon: "mdi-receipt-text-plus",
          name: "GerarContrato",
          rota: "/app/gerar_contrato",
          target: "_self",
          class: "py-7 mt-7",
          // class: "py-7 mt-7 text-subtitle-1 font-weight-black",
        },
        //####
        // {
        //   title: this.$i18n.t("home.GerarContrato"),
        //   icon: "mdi-plus",
        //   name: "GerarContrato",
        //   rota: "/gerar_contrato",
        //   target: "_blank",
        //   class: "py-7 mt-7",
        // },
        {
          title: this.$i18n.t("home.ConsultarPricing"),
          icon: "mdi-cash",
          name: "Pricing",
          rota: "/app/pricing",
          target: "_self",
          class: "py-7 mt-7",
        },
        {
          title: this.$i18n.t("home.ConsultarCredito"),
          icon: "mdi-account-cash",
          name: "Credito",
          rota: "/app/credito",
          target: "_self",
          class: "py-7 mt-7",
        },
        {
          title: 'Sales Sent Report',
          icon: "mdi-file-table",
          name: "SalesSentReport",
          rota: "/app/sales_sent_report",
          target: "_self",
          class: "py-7 mt-7",
        },
      ];
    },
  },
  mounted() {
    //verificar idioma do usuário
    // eslint-disable-next-line
    // debugger;
  },
};
</script>

<style scoped>
.menuBotoes {
  max-width: 30vw;
  min-width: fit-content;
  /* margin-left: auto; */
  /* margin-right: auto; */
}
</style>
